const initIframe= () => {
	const sections = document.querySelectorAll( 'section.iframe' );

	if ( sections.length ) {
		Array.from( sections ).forEach( ( section ) => {
			const fullscreenBtn = section.querySelector( 'button' );
            
            if (fullscreenBtn)
            {
                fullscreenBtn.addEventListener('click', function(){
                    if (!document.fullscreenElement) {
                        section.requestFullscreen().catch((err) => {
                            alert(
                            `Error attempting to enable fullscreen mode: ${err.message} (${err.name})`,
                            );
                        });
                    } else {
                    document.exitFullscreen();
                    }
                });
            }
		})
	}
}

export {
	initIframe,
};